"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccessTokenService = exports.logoutV2Service = exports.checkUserWithBillingOrIban = exports.updateUserEmailService = exports.unsubscribeService = exports.checkUpdateEmailTokenValidityService = exports.updateEmailAndNewsLetterFirstStepService = exports.updateEmailFirstStepService = exports.resendSubscriptionMail = exports.finalizeCreateAccountService = exports.createNewUserAccount = exports.checkAndGetContractUserService = exports.getNewIdentifiedUserDataServiceOld = exports.getNewIdentifiedUserDataService = exports.invalidateMulesoftCache = exports.removeToken = exports.checkTokenValidityService = exports.sendEmailService = exports.resetPasswordService = exports.initializeUserService = exports.getIdentifiedUserService = exports.getUserLoginService = exports.getAuthenticatedUserService = exports.getTokenService = void 0;
// @ts-ignore
var querystring_1 = __importDefault(require("querystring"));
var axiosInstance_1 = __importDefault(require("../helper/axiosInstance"));
var index_1 = require("../index");
var identifiedUser_1 = __importDefault(require("../models/identifiedUser"));
var userLight_1 = __importDefault(require("../models/userLight"));
var common_1 = require("./common");
var RestrictedClientData_1 = __importDefault(require("../models/RestrictedClientData"));
//TO DO check if used by other apps and then remove this line
/**
 * @deprecated removed
 */
function getTokenService(email, password, isRecaptchaV3, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var TOKEN_URL, config, body, response, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    TOKEN_URL = '/auth';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = void 0;
                    if (captchaToken) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                'g-recaptcha-response': captchaToken
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };
                    }
                    body = {
                        username: email.trim(),
                        password: password,
                        client_id: index_1.urlsConfig.values.KEYCLOAK_CLIENT_ID,
                        grant_type: 'password',
                        scope: index_1.urlsConfig.values.KEYCLOAK_SCOPE,
                        isRecaptchaV3: isRecaptchaV3,
                        captchaToken: captchaToken ? true : false
                    };
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(TOKEN_URL), body, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_1 = _a.sent();
                    (0, common_1.LogError)(e_1);
                    throw e_1;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getTokenService = getTokenService;
function getAccessTokenService(email, password, isRecaptchaV3, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var TOKEN_URL, config, body, response, e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    TOKEN_URL = '/v2/auth';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = void 0;
                    if (captchaToken) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                'g-recaptcha-response': captchaToken
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };
                    }
                    body = {
                        username: email.trim(),
                        password: password,
                        client_id: index_1.urlsConfig.values.KEYCLOAK_CLIENT_ID,
                        grant_type: 'password',
                        scope: index_1.urlsConfig.values.KEYCLOAK_SCOPE,
                        isRecaptchaV3: isRecaptchaV3,
                        captchaToken: captchaToken ? true : false
                    };
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(TOKEN_URL), body, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_2 = _a.sent();
                    (0, common_1.LogError)(e_2);
                    throw e_2;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getAccessTokenService = getAccessTokenService;
function getUserLoginService(clientId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var TOKEN_URL, config, response, e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    TOKEN_URL = '/users/logins/';
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = { headers: { Authorization: "Bearer ".concat(token) } };
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(TOKEN_URL).concat(clientId), config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_3 = _a.sent();
                    (0, common_1.LogError)(e_3);
                    throw e_3;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getUserLoginService = getUserLoginService;
function getIdentifiedUserService(email, password) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/identifieduser';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };
                    body = JSON.stringify({
                        login: email.trim(),
                        password: password
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new identifiedUser_1.default(response.data)];
            }
        });
    });
}
exports.getIdentifiedUserService = getIdentifiedUserService;
function unsubscribeService(clientId, token) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/users/".concat(clientId, "/unsubscription");
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    body = JSON.stringify({
                        token: token,
                        clientId: clientId
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.unsubscribeService = unsubscribeService;
function initializeUserService(email, password, newPassword, origin) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/v1.1/initializeuser';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    if (origin) {
                        config = {
                            headers: {
                                'Content-Type': 'application/json',
                                Origin: origin
                            }
                        };
                    }
                    else {
                        config = {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        };
                    }
                    body = JSON.stringify({
                        login: email.trim(),
                        password: password,
                        newPassword: newPassword
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.initializeUserService = initializeUserService;
function invalidateMulesoftCache(token) {
    return __awaiter(this, void 0, void 0, function () {
        var MULESOFT_CACHE_URL, config, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    MULESOFT_CACHE_URL = '/users/mulesoft/proxy_as_keycloak/token';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    return [4 /*yield*/, axiosInstance_1.default.delete("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(MULESOFT_CACHE_URL), config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.invalidateMulesoftCache = invalidateMulesoftCache;
function removeToken(_refresh_token) {
    return __awaiter(this, void 0, void 0, function () {
        var TOKEN_URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    TOKEN_URL = '/logout';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded'
                        }
                    };
                    body = querystring_1.default.stringify({
                        refresh_token: _refresh_token,
                        client_id: index_1.urlsConfig.values.KEYCLOAK_CLIENT_ID
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.KEYCLOAK_URL).concat(TOKEN_URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.removeToken = removeToken;
function logoutV2Service(_refresh_token, token, clientId) {
    return __awaiter(this, void 0, void 0, function () {
        var config, body, route, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    body = JSON.stringify({
                        refreshToken: _refresh_token,
                        clientId: clientId,
                        clientIdIdp: 'frontjs-client'
                    });
                    route = "".concat(index_1.urlsConfig.values.ADMIN_BASE_URL, "/users/logout");
                    return [4 /*yield*/, axiosInstance_1.default.post(route, body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.logoutV2Service = logoutV2Service;
function resetPasswordService(tokenMail, _newPassword) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/resetpassword';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(tokenMail)
                        }
                    };
                    body = JSON.stringify({
                        token: tokenMail,
                        password: _newPassword
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.resetPasswordService = resetPasswordService;
function sendEmailService(_email, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response, e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/sendmailforgetpassword';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': captchaToken
                        }
                    };
                    body = JSON.stringify({
                        email: _email.trim()
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_4 = _a.sent();
                    throw e_4;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.sendEmailService = sendEmailService;
function checkUserWithBillingOrIban(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/identified_users/search";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': payload.captchaToken
                        }
                    };
                    body = {
                        currentEmail: payload.currentEmail,
                        newEmail: payload.newEmail,
                        invoiceReference: payload.invoiceReference,
                        ibanLastFiveNumber: payload.ibanLastFiveNumber
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkUserWithBillingOrIban = checkUserWithBillingOrIban;
function updateUserEmailService(payload) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/identified_users";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': payload.captchaToken
                        }
                    };
                    body = {
                        currentEmail: payload.currentEmail,
                        newEmail: payload.newEmail,
                        invoiceReference: payload.invoiceReference,
                        ibanLastFiveNumber: payload.ibanLastFiveNumber
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.put("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateUserEmailService = updateUserEmailService;
function checkTokenValidityService(_token) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/checktokenvalidity';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };
                    body = JSON.stringify({
                        token: _token
                    });
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkTokenValidityService = checkTokenValidityService;
function getAuthenticatedUserService(token) {
    return __awaiter(this, void 0, void 0, function () {
        var route, config, response, e_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    route = '/v2/auth';
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.get("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new userLight_1.default(response.data)];
                case 3:
                    e_5 = _a.sent();
                    throw e_5;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getAuthenticatedUserService = getAuthenticatedUserService;
function getNewIdentifiedUserDataServiceOld(userReferenceId, userName, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, response, e_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/v1/subscription/search";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': captchaToken
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), { clientReference: userReferenceId, lastName: userName }, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_6 = _a.sent();
                    throw e_6;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getNewIdentifiedUserDataServiceOld = getNewIdentifiedUserDataServiceOld;
function getNewIdentifiedUserDataService(userReferenceId, userName, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, response, e_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/v2.1/subscription/search";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': captchaToken
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), { clientReference: userReferenceId, name: userName }, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, new RestrictedClientData_1.default(response.data)];
                case 3:
                    e_7 = _a.sent();
                    throw e_7;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.getNewIdentifiedUserDataService = getNewIdentifiedUserDataService;
function checkAndGetContractUserService(clientReference, name, captchaToken) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response, e_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/clients/contracts";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': captchaToken
                        }
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    body = JSON.stringify({
                        clientReference: clientReference.trim(),
                        name: name
                    });
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_URL).concat(URL), body, config)];
                case 2:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/, response.data];
                case 3:
                    e_8 = _a.sent();
                    (0, common_1.LogError)(e_8);
                    throw e_8;
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.checkAndGetContractUserService = checkAndGetContractUserService;
function createNewUserAccount(userReference, userName, emailAddress, acceptSaurContact, captchaToken, version) {
    if (version === void 0) { version = 'v1'; }
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/".concat(version, "/subscription/clients");
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'g-recaptcha-response': captchaToken
                        }
                    };
                    body = {
                        name: userName,
                        reference: userReference,
                        email: emailAddress.trim(),
                        acceptSaurContact: acceptSaurContact
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.createNewUserAccount = createNewUserAccount;
function resendSubscriptionMail(userReference, userName, emailAddress, acceptSaurContact, version) {
    if (version === void 0) { version = 'v1'; }
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/".concat(version, "/subscription/clients/resend");
                    config = {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    };
                    body = {
                        name: userName,
                        reference: userReference,
                        email: emailAddress.trim(),
                        acceptSaurContact: acceptSaurContact
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.resendSubscriptionMail = resendSubscriptionMail;
function finalizeCreateAccountService(token, password, version) {
    if (version === void 0) { version = 'v1'; }
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/".concat(version, "/subscription/clients");
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    body = {
                        password: password
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.put("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.finalizeCreateAccountService = finalizeCreateAccountService;
function updateEmailFirstStepService(token, currentEmail, newEmail) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = "/users/emails";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    body = {
                        currentEmail: currentEmail.trim(),
                        newEmail: newEmail.trim()
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateEmailFirstStepService = updateEmailFirstStepService;
function updateEmailAndNewsLetterFirstStepService(token, currentEmail, newEmail, contactByEmail) {
    return __awaiter(this, void 0, void 0, function () {
        var route, config, body;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    route = "/users/emails";
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(token)
                        }
                    };
                    body = {
                        currentEmail: currentEmail.trim(),
                        newEmail: newEmail.trim(),
                        contactByEmail: contactByEmail
                    };
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(route), body, config)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.updateEmailAndNewsLetterFirstStepService = updateEmailAndNewsLetterFirstStepService;
function checkUpdateEmailTokenValidityService(_token) {
    return __awaiter(this, void 0, void 0, function () {
        var URL, config, body, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    URL = '/emailconfirmations';
                    if (!index_1.urlsConfig.values)
                        throw Error('No urls config found');
                    config = {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: "Bearer ".concat(_token)
                        }
                    };
                    body = JSON.stringify({});
                    return [4 /*yield*/, axiosInstance_1.default.post("".concat(index_1.urlsConfig.values.ADMIN_BASE_URL).concat(URL), body, config)];
                case 1:
                    response = _a.sent();
                    (0, common_1.LogRequestResponse)(response);
                    return [2 /*return*/];
            }
        });
    });
}
exports.checkUpdateEmailTokenValidityService = checkUpdateEmailTokenValidityService;
